var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPakistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C723E"
    },
    d: "M448,80H48C21.6,80,0,99.2,0,126.4V248l0,0v121.6C0,396.8,21.6,416,48,416h400 c26.4,0,48-19.2,48-46.4V248l0,0V126.4C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085E2F"
    },
    d: "M448,80H48l200,169.6l0,0L444.8,416c26.4,0,51.2-19.2,51.2-46.4V248l0,0V126.4 C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C11414"
    },
    d: "M496,368.8c0,27.2-21.6,47.2-48,47.2H48c-26.4,0-48-20.8-48-48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#054C23"
    },
    d: "M48,80h400c26.4,0,48,19.2,48,46.4V216"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#054C23"
    },
    d: "M136,368v48h312c26.4,0,48-16,48-48H136z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F4F5"
    },
    d: "M136,80H48C21.6,80,0,99.2,0,126.4V248l0,0v121.6C0,396.8,21.6,416,48,416h88V80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "136,80 48,80 136,154.4 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "136,80 48,80 136,106.4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M0,248L0,248v121.6C0,396.8,21.6,416,48,416h88V248H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M0,368c0,32,21.6,48,48,48h88v-48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F4F5"
    },
    d: "M323.2,279.2c-10.4,9.6-24,15.2-36.8,16.8c-18.4,1.6-37.6-4.8-51.2-19.2c-23.2-24.8-22.4-64.8,3.2-88 c8.8-8,18.4-12.8,28.8-15.2c-19.2-0.8-38.4,6.4-53.6,20c-30.4,28.8-32,76-4,106.4c18.4,20,45.6,28,71.2,22.4 c12.8-2.4,25.6-8.8,36-18.4c15.2-14.4,23.2-32.8,24-52C336.8,261.6,331.2,271.2,323.2,279.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3CAD1"
    },
    d: "M299.2,292.8l14.4,12c0,0,1.6-1.6,2.4-2.4c15.2-14.4,23.2-32.8,24-52c-3.2,10.4-8.8,20-17.6,28 C316,285.6,308,290.4,299.2,292.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3CAD1"
    },
    d: "M200,208.8l18.4,16c2.4-12.8,8.8-27.2,19.2-36.8c8.8-8,18.4-12.8,28.8-15.2 c-19.2-0.8-38.4,6.4-53.6,20C208,197.6,204,203.2,200,208.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "302.4,216.8 304,232.8 312,218.4 328,222.4 317.6,210.4 325.6,196 310.4,202.4 300,189.6  300.8,206.4 286.4,212.8 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakistan);
export default __webpack_public_path__ + "static/media/pakistan.93e52589660a76f6b0c94a47468055aa.svg";
export { ForwardRef as ReactComponent };